import { useState, useEffect } from "react";

/**
 * useExternalState - synchronisiert einen externen Wert mit React-State
 */
export function useExternalState<T>(
  valueOrGetter: T | (() => T),
  setter: (v: T) => void,
): [T, (v: T) => void] {
  const [state, setState] = useState(
    valueOrGetter instanceof Function ? valueOrGetter() : valueOrGetter,
  );
  const setExternalValue = (value: T) => {
    setter(value);
    setState(value);
  };

  return [state, setExternalValue];
}
